import React, { useContext, useState } from "react";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../Images/Clariss-Logo.png";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../../firebase.init";
import { signOut } from "firebase/auth";
import { ThemeContext } from "../../../Contexts/ThemeContext";
import SearchedProducts from "../../../Components/SearchedProducts/SearchedProducts";
import Cart from "../../../Components/Cart/Cart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import useScroll from "../../../Hooks/useScroll";

const Navbar = ({ popCart, handlePopCart }) => {
  const [user] = useAuthState(auth);
  const { products } = useContext(ThemeContext);
  const [focus, setFocus] = useState(false);
  const { searchText, setSearchText } = useContext(ThemeContext);
  const { setCategory } = useContext(ThemeContext);
  const [scrollPosition] = useScroll();
  const navigation = useNavigate();


  let highPriorityProducts = [];
  let searchedProducts = [];

  if (searchText.length > 2) {
    searchedProducts = products?.filter((product) =>
      product.name.toLowerCase().includes(searchText?.toLowerCase())
    );
    highPriorityProducts = searchedProducts?.filter(
      (product) => product?.priority.toLowerCase() === "high"
    );
    // highPriorityProducts = [];
  }

  return (
    <div className="w-full hidden lg:block z-10 bg-primary">
      <div className="navbar px-0 py-6 lg:px-10 flex justify-between">
        {/*.................. logo ...................... */}
        <div className="cursor-pointer">
          <Link to="/">
            <img src={logo} className="w-full h-[80px]" alt="" />
          </Link>
        </div>
        {/*.......... search bar............. */}
        <div className="form-control text-black 2xl:w-[60%] lg:w-[50%] relative">
        <form className="input-group" onSubmit={(e)=>{
            e.preventDefault()
            navigation(`/search/${searchText}`);
            setFocus(false)
            }}>
            <input
              type="text"
              className="border border-r-0 border-[#cccccc] w-[100%] px-4"
              placeholder="Search in Clariss"
              onFocus={() => setFocus(true)}
              onBlur={() => {
                setTimeout(() => setFocus(false), 200);
              }}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <button
              type="submit"
              className="btn btn-rounded bg-primary border border-l-0 border-[#cccccc]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 hover:text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </form>

          {/*......... Search result............ */}
          <div>
            <SearchedProducts
              highPriorityProducts={highPriorityProducts}
              searchedProducts={searchedProducts}
              focus={focus}
            />
          </div>
        </div>
        <div>
          <div
            className={` cart-icon mobile-cart-position ${
              scrollPosition > 10 ? " cart-scrolled-50" : "cart-not-scrolled"
            } ${
              scrollPosition > 80 ? "cart-scrolled-80" : "cart-scrolled-50"
            } `}
          >
            <Link to="/customerDashboard" className="hover:text-accent">
              <FontAwesomeIcon
                className="text-[24px] mr-10 mb-2"
                icon={faUser}
              ></FontAwesomeIcon>
            </Link>
          </div>
          <Cart popCart={popCart} handlePopCart={handlePopCart}></Cart>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
